<template>
  <div class="contact">
    <Header></Header>
    <nav class="banner">
      <div class="title">{{ langData.home.title46 }}</div>
      <div class="title1" v-html="langData.home.title47"></div>
      <div class="form">
        <Form ref="form" :model="form" label-position="top" :rules="ruleInline">
          <FormItem
            class="form_tiem"
            prop="firstName"
            :label="langData.home.title48"
          >
            <Input
              class="input mr_30"
              v-model="form.firstName"
              :placeholder="langData.home.title57"
            ></Input>
          </FormItem>
          <FormItem
            class="form_tiem"
            prop="email"
            :label="langData.home.title49"
          >
            <Input
              class="input"
              v-model="form.email"
              placeholder="you@example.com"
            ></Input>
          </FormItem>
          <FormItem
            class="mt_32 form_tiem"
            prop="phone"
            :label="langData.home.title50"
          >
            <Input
              class="input mr_30"
              v-model="form.phone"
              :placeholder="langData.home.title58"
            ></Input>
          </FormItem>
          <FormItem
            class="mt_32 form_tiem"
            prop="country"
            :label="langData.home.title51"
          >
            <Input
              class="input"
              v-model="form.country"
              :placeholder="langData.home.title59"
            ></Input>
          </FormItem>
          <FormItem class="mt_32" prop="message" :label="langData.home.title52">
            <Input
              type="textarea"
              :placeholder="langData.home.title56"
              v-model="form.message"
            ></Input>
          </FormItem>
          <FormItem label="">
            <span class="infoText">
              {{ langData.home.title53 }}
            </span>
          </FormItem>
          <FormItem label="">
            <Button type="primary" @click="submit('form')">{{
              langData.home.title54
            }}</Button>
          </FormItem>
        </Form>
      </div>
    </nav>
    <Footer></Footer>
  </div>
</template>

<script>
import apiUrl from "../../services/api/user.service";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { Notice } from "iview";
import { mapState } from "vuex";
import store from "../../store/index";
import localStorage from "../../services/localStorage.service";
const getAndSet = function(name) {
  return {
    // getter
    get: function() {
      return this.$store.state.module[name];
    },
    // setter
    set: function(newValue) {
      this.$store.state.module[name] = newValue;
    }
  };
};
export default {
  name: "",
  data() {
    return {
      form: {
        firstName: "",
        country: "",
        email: "",
        phone: "",
        message: ""
      },
      ruleInline: {
        firstName: [
          {
            required: true,
            message: "Please fill in the name",
            trigger: "blur"
          }
        ],
        country: [
          {
            required: true,
            message: "Please fill in the country",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "Please fill in the phone",
            trigger: "blur"
          }
        ],
        message: [
          {
            required: true,
            message: "Please fill in the message",
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: "Please fill in the email",
            trigger: "blur"
          },
          {
            type: "email",
            message: "Email format is error",
            trigger: "blur"
          }
        ]
      },
      langData: {
        home: {
          languageOption: []
        }
      }
    };
  },
  methods: {
    submit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          apiUrl.customer(this.form).then(res => {
            console.log(res);
            this.form.firstName = "";
            this.form.country = "";
            this.form.email = "";
            this.form.message = "";
            this.form.phone = "";
            Notice.success({
              title: "Success"
            });
          });
        }
      });
    },
    changeLanguage() {
      this.$i18n.locale = this.language;
      this.langData = this.$i18n.messages[this.$i18n.locale].message.home;
      this.ruleInline.message[0].message = this.langData.home.title55;
      this.ruleInline.firstName[0].message = this.langData.home.title60;
      this.ruleInline.country[0].message = this.langData.home.title64;
      this.ruleInline.phone[0].message = this.langData.home.title61;
      this.ruleInline.email[0].message = this.langData.home.title62;
      this.ruleInline.email[1].message = this.langData.home.title63;
    }
  },
  components: {
    Header,
    Footer
  },
  created() {
    this.changeLanguage();
  },
  computed: {
    language: getAndSet("language")
  },
  watch: {
    language: function() {
      this.changeLanguage();
      this.$refs["form"].resetFields();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@media all and (min-width: 960px) {
  .contact {
    position: relative;
    width: 100%;
    .banner {
      background: url("../../assets/contactBackground.png") no-repeat;
      background-size: 100%;
      width: 100%;
      padding-top: 200px;
      .title {
        font-size: 56px;
        font-family: Montserrat-SemiBold, Montserrat;
        font-weight: 600;
        color: #ffffff;
        line-height: 68px;
        text-align: center;
      }
      .title1 {
        font-size: 20px;
        font-family: OpenSans-Regular, OpenSans;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
        margin-top: 22px;
        text-align: center;
      }
      .form {
        width: 960px;
        background: #ffffff;
        box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        margin: 0 auto;
        margin-top: 54px;
        margin-bottom: 130px;
        padding: 60px;
        .input {
          width: 401px;
        }
        .mr_30 {
          margin-right: 30px;
        }
        .mt_32 {
          margin-top: 32px;
        }
        .infoText {
          color: #5a7184;
          font-size: 16px;
          line-height: 28px;
          font-family: OpenSans-Regular, OpenSans;
        }
        .form_tiem {
          display: inline-block;
        }
      }
    }
  }
}
@media all and (max-width: 960px) {
  .contact {
    position: relative;
    width: 100%;
    .banner {
      background: url("../../assets/contactBackground.png") no-repeat;
      background-position-x: center;
      background-size: 500%;
      width: 100%;
      padding-top: 100px;
      .title {
        font-size: 32px;
        font-family: OpenSans-SemiBold, OpenSans;
        font-weight: 600;
        color: #ffffff;
        line-height: 40px;
        margin: 0 25px;
        text-align: center;
      }
      .title1 {
        font-size: 15px;
        font-family: OpenSans-Regular, OpenSans;
        font-weight: 400;
        color: #fafafb;
        line-height: 28px;
        margin: 0 35px;
        margin-top: 20px;
        text-align: center;
      }
      .form {
        margin: 0 18px;
        background: #ffffff;
        box-shadow: 0px 10px 35px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        margin-top: 20px;
        margin-bottom: 50px;
        padding: 25px 20px;
        .input {
          width: 100%;
        }
        .mr_30 {
          margin-right: 0px;
        }
        .mt_32 {
          margin-top: 0px;
        }
        .infoText {
          font-size: 12px;
          font-family: OpenSans-Regular, OpenSans;
          font-weight: 400;
          color: #5a7184;
          line-height: 20px;
        }
        .form_tiem {
          display: block;
        }
      }
    }
  }
}
</style>
<style lang="less">
@media all and (min-width: 960px) {
  .ivu-input {
    height: 56px !important;
    background: #ffffff !important;
    border-radius: 8px !important;
    border: 1px solid #c3cad9 !important;
    font-size: 16px !important;
    padding-left: 18px !important;
  }
  textarea.ivu-input {
    height: 137px !important;
    background: #ffffff !important;
    padding: 18px !important;
  }
  .ivu-form .ivu-form-item-label {
    font-size: 16px !important;
    font-family: OpenSans-SemiBold, OpenSans !important;
    font-weight: 600 !important;
    color: #5a7184 !important;
    line-height: 22px !important;
  }
  .ivu-btn,
  .ivu-btn:hover {
    width: 185px !important;
    height: 48px !important;
    background: #002643 !important;
    border-radius: 8px !important;
    font-size: 16px !important;
    font-family: OpenSans-Bold, OpenSans !important;
    font-weight: bold !important;
    color: #ffffff !important;
    line-height: 22px !important;
    border-color: #002643 !important;
  }
  .ivu-form-item-required .ivu-form-item-label:before {
    display: none !important;
  }
}

@media all and (max-width: 960px) {
  .ivu-input {
    height: 40px !important;
    background: #ffffff !important;
    border-radius: 8px !important;
    border: 1px solid #c3cad9 !important;
    font-size: 14px !important;
    padding-left: 16px !important;
  }
  textarea.ivu-input {
    height: 157px !important;
    background: #ffffff !important;
    padding: 16px !important;
  }
  .ivu-form .ivu-form-item-label {
    font-size: 14px !important;
    font-family: OpenSans-SemiBold, OpenSans !important;
    font-weight: 600 !important;
    color: #5a7184 !important;
    line-height: 20px !important;
  }
  .ivu-btn,
  .ivu-btn:hover {
    width: 155px !important;
    height: 48px !important;
    background: #002643 !important;
    border-radius: 8px !important;
    font-size: 15px !important;
    font-family: OpenSans-Bold, OpenSans !important;
    font-weight: bold !important;
    color: #ffffff !important;
    line-height: 20px !important;
    border-color: #002643 !important;
  }
  .ivu-form-item-required .ivu-form-item-label:before {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/home_v2.0/contact.vue